var _regeneratorRuntime = require("/opt/build/repo/node_modules/@babel/runtime/regenerator/index.js");

var _defineProperty = require("/opt/build/repo/node_modules/@babel/runtime/helpers/defineProperty.js");

var _asyncToGenerator = require("/opt/build/repo/node_modules/@babel/runtime/helpers/asyncToGenerator.js");

var _slicedToArray = require("/opt/build/repo/node_modules/@babel/runtime/helpers/slicedToArray.js");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

module.exports = function (e) {
  var t = {};

  function r(n) {
    if (t[n]) return t[n].exports;
    var o = t[n] = {
      i: n,
      l: !1,
      exports: {}
    };
    return e[n].call(o.exports, o, o.exports, r), o.l = !0, o.exports;
  }

  return r.m = e, r.c = t, r.d = function (e, t, n) {
    r.o(e, t) || Object.defineProperty(e, t, {
      enumerable: !0,
      get: n
    });
  }, r.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  }, r.t = function (e, t) {
    if (1 & t && (e = r(e)), 8 & t) return e;
    if (4 & t && "object" == typeof e && e && e.__esModule) return e;
    var n = Object.create(null);
    if (r.r(n), Object.defineProperty(n, "default", {
      enumerable: !0,
      value: e
    }), 2 & t && "string" != typeof e) for (var o in e) {
      r.d(n, o, function (t) {
        return e[t];
      }.bind(null, o));
    }
    return n;
  }, r.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return r.d(t, "a", t), t;
  }, r.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, r.p = "", r(r.s = 1);
}([function (e, t) {
  e.exports = require("react");
}, function (e, t, r) {
  "use strict";

  r.r(t);
  var n = r(0),
      o = r.n(n);

  t.default = function (_ref) {
    var e = _ref.formName,
        t = _ref.preSubmit,
        r = _ref.postSubmit,
        a = _ref.formValues,
        i = _ref.children;

    var _Object = Object(n.useState)(!0),
        _Object2 = _slicedToArray(_Object, 2),
        u = _Object2[0],
        l = _Object2[1];

    Object(n.useEffect)(function () {
      l(!1);
    }, []);

    var c = function c(e) {
      return encodeURIComponent(e).replace(/%20/g, "+");
    },
        f = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(n) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                n.preventDefault();
                _context2.t1 = t;

                if (!_context2.t1) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 5;
                return t();

              case 5:
                _context2.t1 = _context2.sent;

              case 6:
                _context2.t0 = _context2.t1;

                if (_context2.t0) {
                  _context2.next = 9;
                  break;
                }

                _context2.t0 = !t;

              case 9:
                if (!_context2.t0) {
                  _context2.next = 17;
                  break;
                }

                _context2.next = 12;
                return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var t;
                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          _context.next = 2;
                          return fetch("/", {
                            method: "POST",
                            headers: {
                              "Content-Type": "application/x-www-form-urlencoded"
                            },
                            body: (t = _objectSpread(_objectSpread({}, a), {}, {
                              "form-name": e,
                              infoo: p
                            }), Object.entries(t).map(function (e) {
                              return c(e[0]) + "=" + c(e[1]);
                            }).join("&"))
                          });

                        case 2:
                          return _context.abrupt("return", _context.sent);

                        case 3:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                }))();

              case 12:
                if (_context2.sent) {
                  _context2.next = 14;
                  break;
                }

                throw new Error("Error submitting to Netlify");

              case 14:
                r && r();
                _context2.next = 18;
                break;

              case 17:
                console.log("preSubmit false");

              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function f(_x) {
        return _ref2.apply(this, arguments);
      };
    }(),
        _Object3 = Object(n.useState)(""),
        _Object4 = _slicedToArray(_Object3, 2),
        p = _Object4[0],
        s = _Object4[1];

    return u ? o.a.createElement("form", {
      name: e,
      onSubmit: f,
      "data-netlify": "true",
      "netlify-honeypot": "infoo"
    }, i) : o.a.createElement("form", {
      onSubmit: f
    }, i, o.a.createElement("p", {
      style: {
        opacity: "0",
        position: "absolute",
        top: "0",
        left: "0"
      }
    }, o.a.createElement("input", {
      style: {
        width: "0",
        height: "0",
        zIndex: "-1"
      },
      name: "description",
      "aria-label": "description",
      value: p,
      onChange: function onChange(e) {
        return s(e.target.value);
      }
    })));
  };
}]);